export const OSC_WO_DISPLAY_NAME = "Help Center Assistant";

export const routes = {
  home: "/",
  accountSwitcher: "/accounts",
  articles: "articles/:articleSlug",
  categoryView: "/categories/:categoryId",
  deflectionSearchResults: "/search",
  sectionView: "/sections/:sectionId,",
  subaccounts: "/subaccounts",
  supportPlans: "/support-plans",
  ticketDetails: "/tickets/:ticketId",
  ticketHistory: "/tickets",
  ticketSubmission: "/submit",
};

export const authenticatedRoutes = [
  routes.accountSwitcher,
  routes.subaccounts,
  routes.supportPlans,
  routes.ticketDetails,
  routes.ticketHistory,
];
